import { useRecoilState } from 'recoil';
import toggleAtom from '../atoms/toggleAtom';

const ToggleButton = () => {
    const [toggle, setToggle] = useRecoilState(toggleAtom);

    return (
        <div className="flex border border-gray-300 rounded-full overflow-hidden">
            <button className={`px-4 py-1 text-sm font-medium ${toggle === "b2c" ? "bg-customOne text-white" : "bg-white text-gray-600"}`}
                onClick={() => {
                    setToggle("b2c");
                }}>
                B2C
            </button>
            <button className={`px-4 py-1 text-sm font-medium ${toggle === "b2b" ? "bg-customOne text-white" : "bg-white text-gray-600"}`}
                onClick={() => {
                    setToggle("b2b");
                }}>
                B2B
            </button>
        </div>
    );
}
export default ToggleButton;
